import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/User';
import { Observable } from 'rxjs';
import { Table } from '../models/Table';
import { Venue } from '../models/Venue';

import { environment } from '../../environments/environment';
import { PreorderType } from '../models/PreorderType';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	constructor(private http: HttpClient) {}

	BASE_URL = environment.apiUrl;
	AUTH_URL = '/v1/auth';
	GENERAL_URL = '/v1/general';
	DELIVEROO = '/v1/deliveroo';
	MONITORING_URL = '/v1/monitoring';

	login(data: { email: String; password: String }): Observable<User> {
		return this.http.post<User>(`${this.BASE_URL}${this.AUTH_URL}/login`, data);
	}

	refresh(refreshToken: string) {
		return this.http.post<User>(`${this.BASE_URL}${this.AUTH_URL}/refresh`, {
			refreshToken,
		});
	}
	// get venue by customer group  ->
	getTablesVenue(id: string): Observable<Table[]> {
		return this.http.get<Table[]>(`${this.BASE_URL}${this.GENERAL_URL}/venue/${id}/tables`);
	}
	getVenue(id: string) {
		return this.http.get<Venue>(`${this.BASE_URL}${this.GENERAL_URL}/venue/${id}`);
	}
	activateDeactivateActivateUber(venueId: string, value: boolean, snoozed: string) {
		let obj = {
			status: value,
		} as any;
		if (snoozed) {
			obj = { ...obj, snoozed: snoozed };
		}
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/uber-eats`, obj, {
			observe: 'response',
			responseType: 'text',
		});
	}
	activateDeactivateActivateWolt(venueId: string, value: boolean, snoozed: string) {
		let obj = {
			status: value,
		} as any;
		if (snoozed) {
			obj = { ...obj, snoozed: snoozed };
		}
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/wolt`, obj, {
			observe: 'response',
			responseType: 'text',
		});
	}

	activateDeactivateActivateDeliveroo(venueId: string, value: boolean, snoozed: string) {
		let obj = {
			status: value,
		} as any;
		if (snoozed) {
			obj = { ...obj, snoozed: snoozed };
		}
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/deliveroo`, obj, {
			observe: 'response',
			responseType: 'text',
		});
	}

	updateVenue(venue: Venue) {
		return this.http.patch<Venue>(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venue._id}`, {
			...venue,
		});
	}

	updateVenueDeliveryPickupAndOwnDelivery(venue: Venue, value: boolean, snoozed: string, preorderType: PreorderType) {
		const type = preorderType === PreorderType.TAKE_AWAY ? 'takeAway' : 'delivery';
		let obj = {
			[type]: { enabled: value },
		} as any;
		if (snoozed) {
			obj = { [type]: { ...obj[type], snoozed: snoozed } };
		}
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venue._id}/preorder/status`, obj, {
			observe: 'response',
			responseType: 'text',
		});
	}

	changeOrderOffsetWolt(
		venueId: string,
		value: {
			deliveryTime: number;
			preparationTime: number;
		}
	) {
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/wolt/offsets`, value);
	}
	changeOrderOffsetUber(
		venueId: string,
		value: {
			preparationTime: number;
		}
	) {
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/uber-eats/offsets`, value);
	}
	updateOffsetsVenue(
		venueId: string,
		data: {
			preparationTime: number;
		}
	) {
		return this.http.patch(`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/offsets`, data);
	}

	forgotPassword(email: string): Observable<any> {
		const payload = {
			email,
			ocu: true,
			customerGroup: environment.customerGroup,
		};
		return this.http.patch(`${this.BASE_URL}${this.AUTH_URL}/password/request`, payload, { responseType: 'text' });
	}
	resetPassword(token: string, password: string): Observable<string> {
		const payload = {
			password,
			confirmation: password,
			passwordConfirmation: password,
			token,
		};

		return this.http.patch(`${this.BASE_URL}${this.AUTH_URL}/password`, payload, { responseType: 'text' });
	}
}
